import { HttpErrorResponse } from '@angular/common/http';

import type { InterviewResult } from '@recruitee/interview-results-types';
import { createActions, ngrxEvent } from '@recruitee/ngrx';

const namespace = 'viewboxInterviewRequest';

export const ViewboxInterviewRequestActions = createActions(namespace, {
  sendResults: ngrxEvent<{
    value: any;
    interviewTemplateToken: string;
    interviewRequestLinkToken: string;
  }>(),
  sendResultsSuccess: ngrxEvent<Partial<InterviewResult>>(),
  sendResultsFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
